const ACTIVE_LEGACY_PLANS = new Set(["paid", "active", "settled"]);

export const toLegacySubscriptionNumber = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : 0;
};

export const normalizeLegacySubscriptionPlan = (value) =>
  String(value || "").trim().toLowerCase();

export function computeLegacySubscriptionStatus(sub = {}, studentCount = 0) {
  const plan = normalizeLegacySubscriptionPlan(sub?.plan);
  const slots = toLegacySubscriptionNumber(sub?.slot ?? sub?.slots);
  const total = toLegacySubscriptionNumber(studentCount);

  if (plan === "trial") {
    return { active: true, decidedBy: "trial", plan, slots, total };
  }

  const paidLikePlan = ACTIVE_LEGACY_PLANS.has(plan);
  return {
    active: paidLikePlan && slots >= total,
    decidedBy: paidLikePlan ? "paid+slots>=students" : `plan:${plan || "none"}`,
    plan,
    slots,
    total,
  };
}
